import { type StreamError } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

export class StreamErrorException extends Error implements RovoInstrumentedError {
	detail: Pick<StreamError, 'message' | 'metadata'> &
		Partial<Pick<StreamError, 'millisOffset' | 'type'>>;
	errorAttributes: RovoInstrumentedError['errorAttributes'];

	constructor(
		message: string,
		params: {
			detail: Pick<StreamError, 'message' | 'metadata'> &
				Partial<Pick<StreamError, 'millisOffset' | 'type'>>;
			traceId: string | undefined;
		},
	) {
		const { detail, traceId } = params;

		super(message);
		this.name = this.constructor.name;
		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, this.constructor);
		}

		this.detail = detail;

		this.errorAttributes = {
			errorCode: this.detail.message.message_template,
			statusCode: this.detail.message.status_code,
			rawErrorMessage: this.detail.message.content,
			// in case there is no traceId, we generate one in FE
			// and make it distinguishable from BE generated traceId
			// appended by random 5 digit number
			traceId: traceId ?? `StreamError-${generateTraceId()}`,
			requestId: this.detail.metadata?.request_id,
			latestStreamMessageType: this.detail.type,
			latestStreamMessageMillisOffset: this.detail.millisOffset,
		};
	}
}
